import { callApiWithoutToken } from './api';

import { UpdateBoardingGetOffReservationsRequest } from '@/types/pickupDropoff';

export const updateStaffTransportReservations = async (
  line_id: string,
  lineAccessToken: string,
  office_id: string,
  input: UpdateBoardingGetOffReservationsRequest
) => {
  const { status, result } = await callApiWithoutToken<boolean>(
    `line/${line_id}/staff/offices/${office_id}/transport-reservations`,
    'PUT',
    lineAccessToken,
    undefined,
    input
  );
  return { status, result };
};
